<div id="layout" class="qr_code f_col" [class.loading]="!request" [class.error]="errorLoading">
  <div class="scroll_wrapper resp_wrapper">
    <div class="resp_c-50 resp_scroll-wrapper_l">
      <div class="mt_40 text_center" *ngIf="api.userInfo">
        <h1>{{'qr.title' | translate}}</h1>
        <span class="mb_30">{{('qr.desc.DYN.') | translate}}</span>
      </div>
      <div class="mt_40 text_center" *ngIf="!api.userInfo">
        <h1>{{'qr.quicklook' | translate}}</h1>
        <span
          class="text_center mb_30">{{request?.internalIndexedData || ((errorLoading ? 'qr.faked' : 'qr.nosuch') | translate)}}</span>
      </div>
      <div class="f_center mb_40">
        <div class="qrcode mt_40">
          <qrcode *ngIf="qr.qrCode" class="f_center" [qrdata]="qr.qrCode" [width]="300" [errorCorrectionLevel]="'M'"
                  allowEmptyString="true"></qrcode>
        </div>
      </div>
      <div class="f_col gap_10">
        <ng-container *ngIf="api.userInfo">
          <form id="form" [formGroup]="form" class="mt_20">
            <app-input *ngIf="BTdevices" icon="print" type="select" formCtrlName="devices" [formGrp]="form"
                       label="{{'print.name' | translate}}" [selectOptions]="printSO"
                       (change)="changeSelect($event)"></app-input>
          </form>
          <app-button *ngIf="device.isDevices('cordova')" formId="form" class="fullWidth"
                      (btnClicked)="print()">{{'global.print_c7' | translate}}
          </app-button>
        </ng-container>
      </div>

      <div class="resp_minSize_l mt_20 flex gap_10">
        <app-button size="xsm" color="transparent" border="true" class="fullWidth" (btnClicked)="nav.to('dashboard')">
          {{'global.close' | translate}}
        </app-button>
      </div>
    </div>
  </div>

  <div class="f_align_end mb_20 resp_maxSize_l">
    <app-back-btn class="mr_10" icon="house" [navTo]="{route: 'dashboard'}"></app-back-btn>
    <app-back-btn (btnClicked)="nav.goBack()"></app-back-btn>
  </div>
</div>
